var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.375 6.875C19.3743 6.21218 19.1107 5.57672 18.642 5.10803C18.1733 4.63935 17.5378 4.37572 16.875 4.375H15V3.75C14.9995 3.25288 14.8018 2.77626 14.4503 2.42475C14.0987 2.07323 13.6221 1.87552 13.125 1.875H6.875C6.37788 1.87552 5.90126 2.07323 5.54975 2.42475C5.19823 2.77626 5.00052 3.25288 5 3.75V4.375H3.125C2.46218 4.37572 1.82672 4.63935 1.35803 5.10803C0.889348 5.57672 0.625724 6.21218 0.625 6.875V8.75H19.375V6.875ZM13.75 4.375H6.25V3.75C6.25 3.58424 6.31585 3.42527 6.43306 3.30806C6.55027 3.19085 6.70924 3.125 6.875 3.125H13.125C13.2908 3.125 13.4497 3.19085 13.5669 3.30806C13.6842 3.42527 13.75 3.58424 13.75 3.75V4.375Z",
    fill: "#00858A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.3125C13.125 10.5611 13.0262 10.7996 12.8504 10.9754C12.6746 11.1512 12.4361 11.25 12.1875 11.25H7.8125C7.56386 11.25 7.3254 11.1512 7.14959 10.9754C6.97377 10.7996 6.875 10.5611 6.875 10.3125V10.1562C6.875 10.1148 6.85854 10.0751 6.82924 10.0458C6.79993 10.0165 6.76019 10 6.71875 10H0.625V15.625C0.625 16.288 0.888392 16.9239 1.35723 17.3928C1.82607 17.8616 2.46196 18.125 3.125 18.125H16.875C17.538 18.125 18.1739 17.8616 18.6428 17.3928C19.1116 16.9239 19.375 16.288 19.375 15.625V10H13.2812C13.2398 10 13.2001 10.0165 13.1708 10.0458C13.1415 10.0751 13.125 10.1148 13.125 10.1562V10.3125Z",
    fill: "#00858A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.cf87e5ba6da56d7bdaa088d167d0d981.svg";
export { ForwardRef as ReactComponent };